import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import FilterItemMenuLegacy from './_do_not_import_/FilterItemMenu';
import FilterItemMenuV2, { IFilterItemMenuProps } from './_do_not_import_v2_/FilterItemMenu';

export const FilterItemMenu = (props: IFilterItemMenuProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <FilterItemMenuV2 {...props} />;
  }

  return <FilterItemMenuLegacy {...props} />;
};
